import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrTransposedGrid from "@grapecity/wijmo.react.grid.transposed"
import _ from "lodash"

import { useEffect, useRef, useState } from "react"
import CONSTANT from "../../../constant"
import { T配車件数 } from "../../../service/dashboard/TDashboard"
import { T付替受信件数 } from "./HaisyaKensu"

const create部所別付替受信件数一覧 = (付替配車件数: T配車件数[]) => {
  const 付替配車件数部所別集計 = _.groupBy(付替配車件数, "受注部所略称")
  const 部所別付替受信件数Inner: T付替受信件数 = {}

  Object.keys(付替配車件数部所別集計).forEach((key) => {
    部所別付替受信件数Inner[key] = _.sumBy(
      付替配車件数部所別集計[key],
      "配車件数"
    )
  })
  return 部所別付替受信件数Inner
}

/**
 * 付替受信件数グリッド
 * @param props
 * @returns
 */
export const TukekaeZyusinKensuGrid: React.FC<{
  haisyaKensu: T配車件数[] | null | undefined
  busyoCode: string | null | undefined
}> = (props) => {
  const gridRef = useRef<wjrGrid.FlexGrid>(null)

  const [受信部所数, set受信部所数] = useState<number>()

  useEffect(() => {
    if (
      gridRef == null ||
      gridRef.current == null ||
      gridRef.current.control == null ||
      props.haisyaKensu == null
    )
      return

    const grid = gridRef.current.control as wjcGrid.FlexGrid

    const 付替配車件数 = props.haisyaKensu.filter((e) => {
      // 運行部所の場合
      if (wjcCore.isNullOrWhiteSpace(props.busyoCode ?? "")) {
        return e.受注部所ID !== e.運行部所ID
      }
      return (
        e.受注部所コード !== props.busyoCode &&
        e.運行部所コード === props.busyoCode
      )
    })

    const 受信部所一覧 = create部所別付替受信件数一覧(付替配車件数)

    set受信部所数(Object.keys(受信部所一覧).length)
    grid.itemsSource = [受信部所一覧]
  }, [props.haisyaKensu, props.busyoCode])

  return (
    <>
      <div className={受信部所数 == null || 受信部所数 <= 0 ? "d-none" : ""}>
        <wjrTransposedGrid.TransposedGrid
          className="w-19rem max-h-8rem"
          {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
          headersVisibility={wjcGrid.HeadersVisibility.Row}
          ref={gridRef}></wjrTransposedGrid.TransposedGrid>
      </div>
      {(受信部所数 == null || 受信部所数 <= 0) && (
        <div>付替えは行われていません。</div>
      )}
    </>
  )
}
